const GuidRegex = "([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})";
export class Paths {
	static NotFound = "*";
	static Dashborad = "/";
	static ContentConversationBuilder = `/conversationbuilder/:pagetype/:id${GuidRegex}`;
	static ExposureConversationBuilder = `/conversationbuilder/:contentId${GuidRegex}/:pagetype/:id`;
	static MasterConversationBuilder = "/conversationbuilder/master/:pagetype/:id?";
	static PermissionManager = "/usermanagement/permissionmanager";
	static ContentAdministrator = "/usermanagement/contentadministrator";
	static CategoryManager = "/listmanagement/categorymanager";
	static UnitList = "/listmanagement/unitlist";
	static AssetList = "/activelearn/assetlist";
	static WordManager = "/curriculummanagement/wordmanager";
	static PhonogramManager = "/curriculummanagement/phonogram-manager";
	static RevisionManager = "/curriculummanagement/revision-manager";
	static Components = "/curriculummanagement/components";
	static ObjectiveManager = "/curriculummanagement/objective";
	static Text = "/curriculummanagement/components/text";
	static EditText = "/curriculummanagement/components/text/:id";
	static ManageChapters = "/curriculummanagement/components/manageChapters";
	static EditManageChapters = "/curriculummanagement/components/manageChapters/:id";
	static ContentObjective = "/curriculummanagement/components/title/:id/contentobjective";
	static ContentExposure = "/curriculummanagement/components/title/:id/contentexposures";
	static REP = "/curriculummanagement/components/title/:id/rep";
	static Media = "/curriculummanagement/components/:id/media";
	static FocusWordsTab = "/curriculummanagement/components/:id/focuswords";
	static NonCurriculumComponents = "/curriculummanagement/noncurriculumcomponents";
	static NonCurriculumComponentsText = "/curriculummanagement/noncurriculumcomponents/text";
	static NonCurriculumComponentsEditText = "/curriculummanagement/noncurriculumcomponents/text/:id";
	static NonCurriculumComponentsMedia = "/curriculummanagement/noncurriculumcomponents/:id/media";
	static TeachingActivities = "/curriculummanagement/common/teachingactivities";
	static Transitions = "/curriculummanagement/common/transitions";
	static ScopeSequence = "/curriculummanagement/reports/scopesequence";
	static ComponentObjectives = "/curriculummanagement/reports/componentobjectives";
	static UnitOverview = "/curriculummanagement/reports/unitoverview";
	static VpcOverview = "/curriculummanagement/reports/vpcoverview";
	static ComponentToObjective = "/curriculummanagement/reports/component-objective";
	static MasteryQuestionToObjective = "/curriculummanagement/reports/masteryquestion-objective";
	static FocusWordsByChapter = "/curriculummanagement/reports/focuswords-chapter";
	static MediaChangeImpact = "/curriculummanagement/reports/media-change-impact";
	static LessonPlanVersion = "/lessonplan/versions";
	static LessonPlanList = "/lessonplan/list";
	static LessonPlanListWithParams = "/lessonplan/list/:versionGroupId/:methodology/:lessonPlanVersionId";
	static MasterPlan = "/lessonplan/list/masterplan/:versionGroupId/:methodology/:lessonPlanVersionId/:unitId";
	static ConversationMasterBuilder = "/lessonplan/list/convmasterbuilder/:lessonPlanVersionId/:methodology/:unitId";
	static MasterPlanLessonPlanEditor =
		"/lessonplan/list/masterplan/:versionGroupId/:methodology/:lessonPlanVersionId/:unitId/:lessonPlanId";
	static LessonPlanTemplate = "/activelearn/template";
	static StudentActivities = "/activelearn/activities";
	static AddLessonPlanTemplate = "/lessonplan/template/add";
	static EditLessonPlanTemplate = "/lessonplan/template/:templateId/edit";
	static LFSearch = "/languagefunctionmanagement/tagsearch"; //  Tag Search
	static LanguageFunctionTagList = "/languagefunctionmanagement/taglist"; // Tag List
	static TotalReport = "/languagefunctionmanagement/tagusagestatistics"; // TagUsageStatistics
	static DetailsReport = "/languagefunctionmanagement/tagusagedetails"; // Tag Usage Details
	static TextAnalysis = "/textanalysis/newtextanalysis";
	static ReaderWriterTextAnalysis = "/textanalysis/readerwriteranalysis";
	static TextChangeAnalysis = "/textanalysis/textchangeanalysis";
	static TextWriterWordCount = "/vocabulary/wordcount";
	static WordPhraseSearch = "/vocabulary/wordphrasesearch";
	static WordSpec = "/vocabulary/wordspec"; // Word Details
	static WordCount = "/wordanalysis";
	static AssignedWords = "/wordmanager/assignedwords";
	static ExposureWords = "/wordmanager/exposurewords";
	static LevelWords = "/wordmanager/levelwords";
	static TextWriter = "/textwriter";
	static TextGuardian = "/textguardian";
	static Subtitles = "/textguardian/titlelist/subtitles";
	//static Components = "/textguardian/titlelist/components";
	static ComponentConversation = "/curriculummanagement/components/:id/conversations";
	static TitlePhraseList = "/textguardian/titlelist/phraselist/:id";
	static VocabularyList = "/textguardian/vocabularylist";
	static PhraseList = "/textguardian/phraselist";
	static LanguageFunctions = "/textguardian/languagefunctions";
	static Unauthorized = "/unauthorized";
	static UserManagement = "/usermanagement";
	static VersionManagement = "/versionmanagement";
	static ConversationTemplates = "/templates";
	static Fallback = "/templates/fallback";
	static Conversations = "/listmanagement/conversations";
	static OpenClose = "/templates/openclose";
	static UtteranceEntities = "/templates/utteranceentities";
	static CommonIntents = "/templates/commonintents";
	static FocusWords = "/curriculummanagement/focuswords";
	static AuditHistory = "/audithistory";
}
